import {
  Table,
  TableCaption,
  TableContainer,
  Tbody,
  Td,
  Th,
  Thead,
  Tr,
  Button,
} from "@chakra-ui/react";
import { IProduct } from "../../../services/graphql/Product";

import { IShipment } from "../../../services/graphql/Shipment";

import { IConsultationProduct } from "../../../services/graphql/ConsultationProduct";
interface ITableConsultation {
  dataConsultation: IConsultationProduct[];
  onClickViewProducts: (products: IProduct) => void;
  onClickResponse: (consultation: IConsultationProduct) => void;
  loadingButtonsOp?: boolean;
}
export const TableConsultation = (props: ITableConsultation) => {
  const {
    dataConsultation,
    onClickViewProducts,
    loadingButtonsOp,
    onClickResponse,
  } = props;
  return (
    <>
      <TableContainer>
        <Table variant="striped" colorScheme="teal">
          <TableCaption>Consultas</TableCaption>
          <Thead>
            <Tr>
              <Th>Mensaje</Th>
              <Th>Respuesta</Th>
              <Th>Producto</Th>
              <Th>Usuario</Th>
            </Tr>
          </Thead>
          <Tbody>
            {dataConsultation.map((consultation) => (
              <Tr>
                <Td>{consultation.message}</Td>
                <Td>
                  {consultation.response ? (
                    consultation.response
                  ) : (
                    <Button
                      isLoading={loadingButtonsOp}
                      onClick={() => {
                        onClickResponse(consultation);
                      }}
                    >
                      Responder
                    </Button>
                  )}
                </Td>
                <Td>
                  <Button
                    isLoading={loadingButtonsOp}
                    onClick={() => {
                      onClickViewProducts(consultation.product);
                    }}
                  >
                    Ver producto
                  </Button>
                </Td>
                <Td>{`${consultation.user.firstname}`}</Td>
              </Tr>
            ))}
          </Tbody>
        </Table>
      </TableContainer>
    </>
  );
};
